import { Injectable } from "@angular/core";
import { IVwapService, CHANNEL_VWAP_SERVICE, Vwap } from "../IVwapService";
import { ENCODABLE_TYPE_ERRORS } from "shared/broker-client-services";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
  FnTransferableArg,
} from "shared/provider-webworker";
import { PairVwap } from "../../model/core/PairVwap";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class VwapReplicaService implements IVwapService {
  protected broker: ClientMessageBroker;

  constructor(protected factory: ClientMessageBrokerFactory) {
    this.broker = this.factory.createMessageBroker(CHANNEL_VWAP_SERVICE, true, true);
  }

  public getVwapForOrders(orderIds: Array<string>, ndfMode: boolean): Promise<Vwap> {
    let request = new UiArguments("getVwapForOrders");

    let arg1 = new FnArg(orderIds, PRIMITIVE);
    request.args = [arg1];

    return this.runOnService(request, new Array<PairVwap>());
  }

  public getVwapForTradeDeals(tradeDealIds: Array<string>): Promise<Vwap> {
    let request = new UiArguments("getVwapForTradeDeals");

    let arg1 = new FnArg(tradeDealIds, PRIMITIVE);
    request.args = [arg1];

    return this.broker.runOnService(request, PRIMITIVE);
  }

  public getVwapForSelectedDeals(deals: CubiqTS.DealImpl[]): Promise<Vwap> {
    let request = new UiArguments("getVwapForSelectedDeals");

    // let arg1 = new FnArg(deals, SerializerTypes.);
    // request.args = [arg1];

    return this.broker.runOnService(request, PRIMITIVE);
  }

  protected runOnService(request: UiArguments, assignable: any = null): Promise<any> {
    return new Promise<any>((res, rej) => {
      this.broker.runOnService(request, PRIMITIVE).then((value: any) => {
        if (value && value.enType && value.enType == ENCODABLE_TYPE_ERRORS) {
          rej(value);
        } else {
          if (assignable && value) {
            value = Object.assign(assignable, value);
          }
          res(value);
        }
      });
    });
  }
}
